import {constant} from '@/const/const.js'

// スタックできる画面履歴の上限
const MAX_STACK_PAGES = 10

export default {
  namespaced: true,
  state: {
    // 画面遷移履歴
    pageHistory: {
      // フッターの機能単位を想定({page,payload})
      Dokoiku: [],
    },
  },
  getters: {
    /**
     * 前画面名の取得
     * @param {*} state Stateオブジェクト
     * @returns 前ページ情報(this.$routeで取得した情報)
     */
    prevDokoikuPage(state) {
      const lastIndex = state.pageHistory.Dokoiku.length - 1 // eslint-disable-line no-magic-numbers
      return state.pageHistory.Dokoiku[lastIndex]?.page
    },
  },
  mutations: {
    /**
     * 画面遷移履歴をスタック
     * @param {*} state Stateオブジェクト
     * @param {Object} payload 画面履歴情報
     * @param {Object} payload.page ページ情報(this.$routeで取得した情報)
     * @param {Object} payload.payload ページに紐づくState情報
     */
    addPageHistory(state, {page, payload}) {
      state.pageHistory.Dokoiku.push({page, payload})
      // スタックした履歴の上限に達した場合、古い履歴から排除していく
      if (MAX_STACK_PAGES < state.pageHistory.Dokoiku.length) {
        const newArray = [...state.pageHistory.Dokoiku.slice(1)] // eslint-disable-line no-magic-numbers
        state.pageHistory.Dokoiku = newArray
      }
    },
    /**
     * 画面遷移履歴をポップ
     * @param {*} state Stateオブジェクト
     */
    popPageHistory(state) {
      state.pageHistory.Dokoiku.pop()
    },
    /**
     * 画面遷移履歴の初期化
     * @param {*} state Stateオブジェクト
     */
    resetPageHistory(state) {
      state.pageHistory.Dokoiku = []
    },
  },
  actions: {
    /**
     * ドコイクの画面履歴と再表示に必要なStore情報を保存
     * @param {*} context コンテキスト
     * @param {*} context.rootState rootState
     * @param {*} context.commit commit
     * @param {*} context.getters getters
     * @param {Object} route 画面情報
     */
    saveDokoikuHistoryPage({rootState, commit, getters}, route) {
      // 既に保持している場合、何も行わない(重複保持の回避)
      const lastPage = getters.prevDokoikuPage
      if (!!lastPage?.name && lastPage.name == route.name) return

      // 各画面名とその画面に必要なStore情報を保持
      let payload = {}
      switch (route.name) {
        case constant.DISPLAY_DOKOIKU_TIMELINE:
          payload = rootState.DokoikuStore.timeline
          break
        case constant.DISPLAY_DOKOIKU_COMMENT_DETAIL:
          payload = rootState.DokoikuStore.commentDetail
          break
        case constant.DISPLAY_DOKOIKU_OTHER_USER_MY_PAGE:
          payload = rootState.DokoikuStore.otherUserMyPage
          break
        case constant.DISPLAY_DOKOIKU_TAG_SEARCH_RESULT:
          payload = rootState.DokoikuStore.tagSearchResult
          break
        case constant.DISPLAY_DOKOIKU_SPOT_DETAIL:
          payload = rootState.DokoikuStore.spotDetail
          break
        case constant.DISPLAY_DOKOIKU_NEARBY_SEARCH_MAP:
          payload = rootState.DokoikuStore.nearbySearch
          break

        default:
          return
      }

      // 遷移元のページ情報を保持
      commit('addPageHistory', {page: route, payload})
    },
    /**
     * 指定した画面の前回表示していたページ情報を復元
     * @param {*} context コンテキスト
     * @param {*} context.state state情報
     * @param {*} context.commit commitメソッド
     * @param {String} pageName 画面名
     */
    restorationDokoikuPage({state, commit}, pageName) {
      // 前のページ情報を探索
      const histories = state.pageHistory.Dokoiku
      const prevPage = histories.findLast((data) => data.page.name == pageName)

      // 復元するページ情報がなければ何もしない
      if (!prevPage) return

      // Storeの値を復元(payloadを利用し一括更新)
      const {payload} = prevPage
      const commitValue = {key: 'all', value: payload}
      switch (pageName) {
        case constant.DISPLAY_DOKOIKU_TIMELINE:
          commit('DokoikuStore/setTimelineInfo', commitValue, {root: true})
          break
        case constant.DISPLAY_DOKOIKU_COMMENT_DETAIL:
          commit('DokoikuStore/setCommentDetailInfo', commitValue, {root: true})
          break
        case constant.DISPLAY_DOKOIKU_OTHER_USER_MY_PAGE:
          commit('DokoikuStore/setOtherUserMyPageInfo', commitValue, {
            root: true,
          })
          break
        case constant.DISPLAY_DOKOIKU_TAG_SEARCH_RESULT:
          commit('DokoikuStore/setTagSearchResultInfo', commitValue, {
            root: true,
          })
          break
        case constant.DISPLAY_DOKOIKU_SPOT_DETAIL:
          commit('DokoikuStore/setSpotDetailInfo', commitValue, {root: true})
          break
        case constant.DISPLAY_DOKOIKU_NEARBY_SEARCH_MAP:
          commit('DokoikuStore/setNearbySearchInfo', commitValue, {root: true})
          break
        default:
      }
    },
  },
}
